import styles from "./breadcrumbs.module.css";
import { UIIconName } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-type";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { UIIconButton } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";
import { usePaths } from "BEDROCK/paths";
export interface BreadcrumbItem {
  label?: string;
  subtitle?: string;
  path?: string;
  iconName?: UIIconName;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  onClick?: (item: BreadcrumbItem) => void;
}
export const Breadcrumbs = ({ items, onClick }: BreadcrumbsProps) => {
  const { navigateTo } = usePaths();

  const handleClick = (item: BreadcrumbItem) => {
    if (item.path) {
      navigateTo(item.path);
    }
    if (onClick) {
      onClick(item);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.list}>
        {items.map((item, index) => (
          <div className={styles.itemContainer} key={index}>
            <div className={styles.item} onClick={() => handleClick(item)}>
              {item.iconName && (
                <UIIconButton
                  iconName={item.iconName}
                  width={20}
                  height={20}
                  onClick={() => {
                    handleClick(item);
                  }}
                />
              )}
              {item.label && <span className="item">{item.label}</span>}
              {index < items.length - 1 && (
                <UIIcon iconName="CHEVRON-RIGHT" variant="REGULAR" size={20} />
              )}
            </div>
            {index === items.length - 1 && item.subtitle && (
              <div className={styles.subtitle}>{item.subtitle}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
